import React from 'react';

export function CleanskinPage() {
  return (
    <div>
        <div className="mb-8">
          <h1 className="text-neutral-900">Cleanskin</h1>
          <p className="text-neutral-600 mt-1">Manage cleanskin inventory</p>
        </div>
      </div>
  );
}

export default CleanskinPage;
